import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchImpcsOfSingleOperator from '../../api/ImpcsOfSingleOperatorAPI';
import { FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_REQUEST, FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_REQUEST } from '../actions/types/ImpcsOfSingleOperatorActionsTypes';
import {
  getImpcsOfSingleInboundOperatorSuccessActionCreator,
  getImpcsOfSingleInboundOperatorFailureActionCreator,
  getImpcsOfSingleOutboundOperatorSuccessActionCreator,
  getImpcsOfSingleOutboundOperatorFailureActionCreator,
} from '../actions/ImpcsOfSingleOperatorActions';

function* doImpcsOfSingleInboundOperatorApplyWorker(action) {
  try {
    const res = yield call(apiFetchImpcsOfSingleOperator, action.payload);
    yield put(getImpcsOfSingleInboundOperatorSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getImpcsOfSingleInboundOperatorFailureActionCreator(error));
  }
}

function* doImpcsOfSingleOutboundOperatorApplyWorker(action) {
  try {
    const res = yield call(apiFetchImpcsOfSingleOperator, action.payload);
    yield put(getImpcsOfSingleOutboundOperatorSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getImpcsOfSingleOutboundOperatorFailureActionCreator(error));
  }
}

function* doImpcsOfSingleOperatorApplyWatcher() {
  yield takeLatest(FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_REQUEST, doImpcsOfSingleInboundOperatorApplyWorker);
  yield takeLatest(FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_REQUEST, doImpcsOfSingleOutboundOperatorApplyWorker);
}

export default doImpcsOfSingleOperatorApplyWatcher;
